import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http} from '@angular/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Constants } from '../Constants/Constants';


@Injectable({
  providedIn: 'root'
})
export class SurveyJobsService {
  searchText: string = "";
  currentLanguage: string = "";
  constructor(private httpclient: HttpClient, private http: Http) { }

  GetHeaders(): HttpHeaders {
    let myHeaders = new HttpHeaders();
   myHeaders.append('Content-Type', undefined);
   //myHeaders.append('Accept', 'application/json');
    return myHeaders;
  }

  GetAllRegions(method: string): Observable<any> {
    return this.http.get(this.getUrls() + Constants.ServiceAPi + method)
      .pipe(map((res: Response) => res.json()),
        catchError((res: Response) => throwError(res)));
  }
  GetAllActiveSurveysWithJobs(method: string, CultureCode: string): Observable<any> {
    return this.http.get(this.getUrls() + Constants.ServiceAPi + method + "?CultureCode=" + CultureCode)
      .pipe(map((res: Response) => res.json()),
        catchError((res: Response) => throwError(res)));
  }
  
  GetJobsBySearchText(method: string, CultureCode: string, searchText: string, searchData: string, pageIndex: string): Observable<any> {
    return this.http.get(this.getUrls() + Constants.ServiceAPi + method + "?SurveyId=" + searchText + "&searchData=" + searchData + "&CultureCode=" + CultureCode + "&pageSize=" + Constants.PageSize + "&pageIndex=" + pageIndex)
      .pipe(
        map((res: Response) => res.json()),
        catchError((res: Response) => throwError(res)));
  }

  GetJobsBySurveyId(method: string, searchText: string, pageIndex: string): Observable<any> {
    return this.http.get(this.getUrls() + Constants.ServiceAPi + method + "?SurveyId=" + searchText + "&pageSize=" + Constants.PageSize + "&pageIndex=" + pageIndex)
      .pipe(
        map((res: Response) => res.json()),
        catchError((res: Response) => throwError(res)));
  }

  ///Common method is used to get data from DNN API
  GetDataFromApi(methodName: string): Observable<any> {
    return this.http.get(this.getUrls() + Constants.ServiceAPi + methodName)
      .pipe(
        map((e: Response) => e.json()),
        catchError((e: Response) => throwError(e))
      );
  }

  getUrls(): string {
    var hostname = window.location.hostname.toLowerCase();
    var apiUrl = "";
    switch (hostname) {
      case Constants.LocalHostName:
        {
          apiUrl = hostname + ":44362";
          break;
        }
      default:
        {
          apiUrl = hostname;
        }
    }
    return "https://" + apiUrl;
  }

  
  getPager(totalItems: number, currentPage: number = 1, pageSize: number = 20) {
    let totalPages = Math.ceil(totalItems / pageSize);

    let startPage: number, endPage: number;

    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    let pages = this._range(startPage, endPage + 1, 1);

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }

  _range = function (start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++ , start += step) {
      range[idx] = start;
    }

    return range;
  };
}
